
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { CreateTechniqueFormValues } from './FormSchema';

interface PersonalNotesFieldProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
}

export const PersonalNotesField: React.FC<PersonalNotesFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="personalNotes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Personal Notes</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Enter your personal notes about this technique" 
              className="min-h-[100px]" 
              {...field} 
            />
          </FormControl>
          <FormDescription>
            These notes will be private to you
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
